import {
  getAdmin,
  getCompanyProfile,
} from "features/account/service/AccountProfileService";
import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";
import storage from "services/storage";

const LayoutComponentContext = createContext(undefined);

export const LayoutComponentProvider = ({ children, setSubscrType }) => {
  const [companyProfile, setCompanyProfile] = useState(null);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    fetchUserBasedOnType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storage.getItem("type")]);

  const fetchUserBasedOnType = useCallback(() => {
    const typeStorage = storage.getItem("type")
    if (typeStorage === "CLIENT") {
      fetchCompany();
    } else if (typeStorage === "ADMIN") {
      fetchAdmin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchCompany = useCallback(async () => {
    const response = await getCompanyProfile();
    storage.setItem("subscrType", response?.data?.subscription_type);
    setSubscrType(response?.data?.subscription_type);
    setCompanyProfile(response?.data);
  }, [setSubscrType]);

  const fetchAdmin = useCallback(async () => {
    const response = await getAdmin();
    setAdmin(response?.data);
  }, []);

  return (
    <LayoutComponentContext.Provider
      value={{
        companyProfile,
        admin,
        refetchCompany: fetchCompany,
        refetchAdmin: fetchAdmin,
        refetchUserBasedOnType: fetchUserBasedOnType,
      }}
    >
      {children}
    </LayoutComponentContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutComponentContext);
  if (context === undefined) {
    throw new Error("useLayout must be used within a LayoutComponentProvider");
  }
  return context;
};
